import { render } from "./reports/report-tpl.html?vue&type=template&id=128ff954&scoped=true&external"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import "./Report.vue?vue&type=style&index=0&id=128ff954&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128ff954"]])

export default __exports__